import { Dashboard } from "@/features/dashboard";
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod/v4";
import type { MetricPeriod } from "../../features/dashboard/types/metricPeriod";
import { isomorphicHttpClient } from "../../httpClient";
import { verifyRoles } from "../../utils/verifyRoles";

const dashboardFiltersSearchParamsSchema = z.object({
  tenantId: z.string().default("").catch(""),
  period: z
    .enum([
      "lastDay",
      "lastWeek",
      "lastMonth",
    ] as const satisfies MetricPeriod[])
    .default("lastDay")
    .catch("lastDay"),
});

export const Route = createFileRoute("/dashboard/")({
  component: Dashboard,
  head: () => ({
    meta: [{ title: "Dashboard - Backoffice Detentora Iniciador" }],
  }),
  validateSearch: dashboardFiltersSearchParamsSchema,
  search: {
    middlewares: [
      stripSearchParams(dashboardFiltersSearchParamsSchema.parse({})),
    ],
  },
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN", "ORG_OPERATOR"]),
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery({
      queryKey: ["tenants"],
      queryFn: async () => {
        const httpClient = isomorphicHttpClient();

        const { data, error } = await httpClient.GET("/v1/tenants");

        if (error) {
          throw new Error(error.message);
        }

        return data;
      },
    });
  },
});
